import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Tooltip, IconButton, DialogContent, DialogActions, Portal} from '@mui/material';
import * as request from 'superagent';
import { saveAs } from "file-saver";
import Dropzone from '~common/components/versioned-document-dropzone';
import ErrorView from "~common/components/error-view";


var MAX_FILE_SIZE = 5242880;

type State = {
    uploadingTemplate?: boolean;
    downloadingTemplate?: boolean;
    templateImportError?: any;
    error?: any;
};

interface Props extends React.HTMLProps<HTMLDivElement> {
   classes: any;
   definition: any;
   confirmationMessage: string;
   onConfirm: ()=>void;
   onClose: ()=>void
   isTerminal?: boolean;
  }

  const styles = (theme:Theme):StyleRules => ({
    container: {
        width: "100%"
    },
        downloadFormTemplateIcon: {
            color: "#8d8d8d",
            fontSize: "1.0rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 8
    },
        allowsMultipleImportIcon: {
            color: "#8d8d8d",
            fontSize: "1.0rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
    },
        dropzoneMin: {
            border: '0px dashed #ccc',
            paddingTop: 8,
            marginLeft: 10,
            marginTop: 0,
            width: '2rem',
            height: '2rem',
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'center',
            cursor: 'pointer'
    },
})

class DefinitionSectionImport extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {}
    }

    downloadImportTemplate = () => {
        this.setState({
            downloadingTemplate: true
        }, ()=>{

            request
            .post("/api/form-definitions/download-form-template")
            .set("Content-Type", "application/json")
            .send(this.props.definition)
            .set("Accept", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            .responseType("blob")
            .then((response) => {
        
                let filename = "template.xlsx";
        
                let disposition = response["headers"]["content-disposition"];
                if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
                }
                
                this.setState({
                    downloadingTemplate: false
                }, ()=>{
                    saveAs(response.body, filename);
                })
            })
            .catch((err) => {
                this.setState({
                    uploadingTemplate: false
                }, ()=>{
                    if (err && err.response && err.response.text) {
                        this.handleAPIError(err.response.text)
                    } else {
                        this.handleAPIError("an error has occured")
                    }
                })
            })
        })
    }

    onDrop = (acceptedFiles: Array<any>, rejectedFiles: Array<any>) => {

        if (rejectedFiles && rejectedFiles.length > 0) {
    
          this.setState({
              error: "invalid file"
          })
         
        } else {
          if (acceptedFiles && acceptedFiles.length > 0) {
            var f = acceptedFiles[0]
    
            var fields = this.props.definition.predefined.map((f:any)=>{
              return  {
                key: f.key,
                title: f.title
              }          
            })
    
            var url = `/api/form-definitions/upload-form-template?fields=${encodeURIComponent(JSON.stringify(fields))}`
            if (this.props.definition.allowsMultiplesTemplateImportTransformChannel) {
             url+= `&allowsMultiplesTemplateImportTransformChannel=${this.props.definition.allowsMultiplesTemplateImportTransformChannel}` 
            }
                
            this.setState({
              uploadingTemplate: true
            }, ()=>{
    
              request
              .post(url)
              .attach(f.name, f)
              .then((response) => {
                if (response.body && response.body.length > 0) {
                 if (response.body.length > 0) {
                   this.props.handleChangeAtPath(
                        this.props.path,
                        response.body
                  );
                 }
                }
                this.setState({uploadingTemplate: false})
              })
              .catch((err: request.Error) => {
                this.setState({
                    uploadingTemplate: false
                }, ()=>{
                    if (err && err.response && err.response.text) {
                        this.handleAPIError(err.response.text)
                    } else {
                        this.handleAPIError("an error has occured")
                    }
                })
              });
            })
          }
        }
    };

    handleAPIError = (err) => {
        this.setState({
            error: err
        })
    }


    onErrorViewClose = () => {
        this.setState({
            error: undefined
        })
    }


    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;

        var {error} = this.state




        var definitionTitle = this.props.definition.title



        var errorView;
        if (error) {
            errorView = (
                <Portal>
                    <ErrorView classes={{}} error={error} onClose={this.onErrorViewClose} />
                </Portal>
            );
        }

        return (

            <div className={classes.container}> 

                {errorView}

                <span style={{display: "inline-block"}}>

                
                {(!this.state.uploadingTemplate && !this.state.downloadingTemplate) && <Tooltip key="dt" title={`Download ${definitionTitle} Template`}>
                    <IconButton
                        className={classes.downloadFormTemplateIcon}
                        aria-label="Download Import Template"
                        color="inherit"
                        onClick={this.downloadImportTemplate.bind(this)}
                        // size="large"
                    >
                        <i
                        style={{ minWidth: "1rem" }}
                        className={"fa fa-file-download"}
                        />
                    </IconButton>
                </Tooltip>}

                { (this.state.uploadingTemplate || this.state.downloadingTemplate) && 
                <IconButton
                    className={classes.downloadFormTemplateIcon}
                    color="inherit"
                >
                    <i  
                        style={{ minWidth: "1rem" }}
                        className={"fas fa-spinner fa-spin"}
                    />
                </IconButton>
                }

            </span>


            <span style={{display: "inline-block"}}>

              {(!this.state.uploadingTemplate && !this.state.downloadingTemplate) && <Dropzone
                multiple={false}
                minSize={undefined}
                maxSize={undefined || MAX_FILE_SIZE}
                accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                className={classes.dropzoneMin}
                disabled={false}
                onDrop={this.onDrop}>
                <Tooltip key="Upload" title={`Upload ${definitionTitle} Template`}>
                  <IconButton
                  className={classes.allowsMultipleImportIcon}
                  aria-label="Upload Template"
                  color="inherit"
                >
                  <i
                    style={{ minWidth: "1rem" }}
                    className={"fa fa-file-upload"}
                  />
                </IconButton>
                </Tooltip>
              </Dropzone>}

              { (this.state.uploadingTemplate || this.state.downloadingTemplate) && 
                <IconButton
                    className={classes.downloadFormTemplateIcon}
                    color="inherit"
                >
                    <i  
                        style={{ minWidth: "1rem" }}
                        className={"fas fa-spinner fa-spin"}
                    />
                </IconButton>
                }

            </span>

         

          </div>
        )
    }
}

export default withStyles(styles)(DefinitionSectionImport);